import { render, staticRenderFns } from "./TutorialComments.vue?vue&type=template&id=77ef8e1b&"
import script from "./TutorialComments.vue?vue&type=script&lang=js&"
export * from "./TutorialComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports